import React from 'react';
import MinimizableMapControl from '../MinimizableMapControl';
import { BgColorsOutlined } from '@ant-design/icons';

const Swatch = ({ color = '#000', label, style = {}, dashed = false, fillOpacity = 0.25 }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
    <div
      style={{
        width: 18,
        height: 12,
        borderRadius: 2,
        background: color,
        opacity: fillOpacity,
        border: `2px ${dashed ? 'dashed' : 'solid'} ${color}`,
        boxSizing: 'border-box',
        ...style,
      }}
    />
    <span style={{ fontSize: 12, color: '#333' }}>{label}</span>
  </div>
);

const LineSwatch = ({ color = '#000', label, dashed = false }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
    <div
      style={{
        width: 18,
        height: 0,
        borderTop: `3px ${dashed ? 'dashed' : 'solid'} ${color}`,
      }}
    />
    <span style={{ fontSize: 12, color: '#333' }}>{label}</span>
  </div>
);

const MapLegend = ({ id = 'map-legend', position = 'bottomright', defaultMinimized = true, dock }) => {
  // Static legend to start; can be made dynamic from map layers later
  const colors = {
    regions: '#1890ff',
    councils: '#52c41a',
    boundary: '#fa8c16',
    selected: '#13c2c2',
  };

  return (
    <MinimizableMapControl
      id={id}
      title="Map Legend"
      icon={<BgColorsOutlined />}
      position={position}
      defaultMinimized={defaultMinimized}
      dock={dock}
      className="map-legend"
    >
      <div style={{ fontSize: 12 }}>
        <Swatch color={colors.regions} label="Regions" />
        <Swatch color={colors.councils} label="Councils (LGAs)" />
      </div>
    </MinimizableMapControl>
  );
};

export default MapLegend;
